import { useSpring, animated } from '@react-spring/web';
import { useState } from 'react';

const TransitionOnLoad = ({ children }) => {
  const [rendered, setRendered] = useState(false);

  const styles = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 600 },
    onRest: () => setRendered(true),
  });

  return (
    <animated.div className="transition-on-load" style={rendered ? {} : styles}>
      {children}
    </animated.div>
  );
};

export default TransitionOnLoad;